import { TriangleAlert } from "lucide-react";
import { Link, useRouteError } from "react-router-dom";
import Logo from "@/components/logo";
import { Button } from "@/components/ui/button";
import { Heading, Text } from "@/components/ui/typography";

export default function ErrorPage() {
  const error = useRouteError();

  let message = "Something went wrong";
  let details = "An unexpected error occurred.";
  let stack: string | undefined;

  if (error instanceof Response) {
    message = error.status === 404 ? "Page not found" : "Something went wrong";
    details =
      error.status === 404
        ? "The page you're looking for doesn't exist or has moved."
        : error.statusText || details;
  } else if (error instanceof Error) {
    details = error.message;
    stack = error.stack;
    console.error(error);
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md space-y-6">
        <Logo className="mx-auto max-h-8" />

        <div className="surface-panel space-y-4 p-6 text-center">
          <div className="mx-auto flex size-11 items-center justify-center rounded-full bg-warning/12 text-warning-foreground">
            <TriangleAlert className="size-5" aria-hidden="true" />
          </div>
          <div className="space-y-1">
            <Heading variant="section" as="h1">
              {message}
            </Heading>
            <Text tone="muted">{details}</Text>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
            <Button asChild variant="light">
              <Link to="/dashboard">Back to dashboard</Link>
            </Button>
            <Button type="button" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>

        {import.meta.env.DEV && stack ? (
          <details className="surface-panel overflow-hidden text-left">
            <summary className="cursor-pointer px-4 py-3 text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
              Stack trace
            </summary>
            <pre className="overflow-x-auto border-t border-border px-4 py-3 text-xs text-muted-foreground">
              <code>{stack}</code>
            </pre>
          </details>
        ) : null}
      </div>
    </div>
  );
}
